import { FC, memo } from 'react';

import InstructorTemplate from '../../components/instructur-template/InstructorTemplate';
import { InstructorTemplateProps } from '../../components/instructur-template/type';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';

const DATA: InstructorTemplateProps = {
  cv: ['geboren 1977', '2003 - 2008 Aikido (Dragisha Jocic, 7. Dan Aikikai)'],
  img: {
    alt: 'Martin Landolt, Gründer und Ausbilder der Systema Akademie Solothurn',
    src: '/img/profile-martin-landolt-250.png',
  },
  name: 'Martin Landolt',
  school: {
    name: 'Systema Akademie Solothurn',
    url: 'https://www.systema-akademie-solothurn.ch',
  },
  systema: [
    <>
      2003 - 2008 <Route href={RoutePath.SystemaRyabko}>Systema Ryabko</Route> (Dragisha Jocic)
    </>,
    <>
      2008 - 2014 Systema Ryabko (<Route href={RoutePath.FalkoZander}>Falko Zander</Route>)
    </>,
    <>
      seit 2014 <Route href={RoutePath.SolovevStyle}>Solovev Defense</Route> (Falko Zander)
    </>,
    <>
      seit 2016 <Route href={RoutePath.KampkunstPu}>Privatschüler</Route> von Falko Zander
    </>,
    <>Gründer, Systema Akademie Solothurn</>,
    <>
      <Route href={RoutePath.KampfkunstInstructorProgram}>Instructor</Route>, Solovev Defense
    </>,
    <>
      <Route href={RoutePath.KampfkunstRanking}>8. Schülergrad</Route>, Solovev Defense
    </>,
  ],
  vision:
    '"Ich geniesse es, dass ich seit Jahren intensiv und leidenschaftlich an der Systema Akademie Berlin trainieren und durch Falko Zander das Wissen von Alexander Solovev erlernen darf. Mit der Systema Akademie Solothurn möchte ich nun den geeigneten Rahmen schaffen, um gemeinsam mit anderen diese faszinierende Form der russischen Kampfkunst durch achtsame Selbsterfahrung und in exakter Selbsterkenntnis erfahren und vertiefen zu können."',
};

const MartinLandolt: FC = () => <InstructorTemplate {...DATA} />;
export default memo(MartinLandolt);
